/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce la visualizzazione degli apparati per filiale
 */
(function() {
  'use strict';
  var VisualizzazioneApparatiCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    visualizzazioneApparatiSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.visualizzazioneApparatiSrvc = visualizzazioneApparatiSrvc;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.ricerca = {
      codice: '',
      descrizione: ''
    };

    this.filialiDaMostrare = [];

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name filtraFiliali
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Filtra le filiali per codice e/o descrizione indicati
     */
    this.filtraFiliali = function(filiali, ricerca) {
      self.filialiDaMostrare = [];
      for (var i in filiali) {
        if (
          (filiali[i].soglia.filiale.search(new RegExp(ricerca.codice, 'i')) >
            -1 &&
            ricerca.codice) ||
          (filiali[i].soglia.descrizione.search(
            new RegExp(ricerca.descrizione, 'i')
          ) > -1 &&
            ricerca.descrizione)
        ) {
          self.filialiDaMostrare.push(filiali[i]);
        }
      }

      if (!self.filialiDaMostrare.length) {
        self.filialiDaMostrare = filiali;
      }
    };

    /**
     * @ngdoc method
     * @name filtraFiliali
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Chiama al servizio che restituisce le filiali
     */
    this.ricercaVisualizzazioneApparati = function(ricerca) {
      self.flusso = {};
      self.dettaglioFlusso = {};
      self.gestioneApparatiFl = false;
      self.spinner.showSpinner = true;
      self.visualizzazioneApparatiSrvc
        .promiseRecuperaFiliali()
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }

            self.spinner.showSpinner = false;

            self.filiali = response.data.result;

            self.filtraFiliali(self.filiali.quantitaSoglie, ricerca);

            self.tableHeight = self.filialiDaMostrare.length * 30 + 40;

            self.stiliTabella = {
              height: self.tableHeight + 'px',
              width: '100%'
            };

            // Configurazione tabella
            self.gridOptions = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              multiSelect: false,
              showHeader: true,
              enableRowHeaderSelection: false,
              enableRowSelection: true,
              // enableRowSelection: !self.propostaTelepassSrvc.isPraticaNavigabile(),
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: true,
              enableCellEditing: false,
              columnDefs: [
                {
                  displayName: 'Filiale',
                  field: 'soglia.filiale',
                  width: '25%',
                  name: 'filiale',
                  enableCellEdit: false
                },
                {
                  displayName: 'Descrizione',
                  field: 'soglia.descrizione',
                  width: '25%',
                  name: 'descrizione',
                  enableCellEdit: false
                },
                {
                  displayName: 'Quantità Disponibile',
                  field: 'quantita',
                  width: '25%',
                  name: 'quantita',
                  enableCellEdit: false
                },
                {
                  displayName: 'Soglia',
                  field: 'soglia.value',
                  width: '25%',
                  name: 'soglia',
                  enableCellEdit: false
                }
              ],
              data: self.filialiDaMostrare,
              onRegisterApi: function(gridApi) {
                gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                  self.selezionaFlusso(row);
                });
              }
            };
          },
          function(reason) {
            if (self.messaggiFctr.processaResponse(reason)) {
              self.spinner.showSpinner = false;
            }
          }
        )
        .finally(function() {
          self.spinner.showSpinner = false;
        });
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      labelSrvc.labelsPronte.then(function() {
        self.labelsPronte = true;
      });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  VisualizzazioneApparatiCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsVisualizzazioneApparatiSrvc'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/visualizzazioneApparati/visualizzazioneApparati.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var visualizzazioneApparatiComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: VisualizzazioneApparatiCtrl,
    controllerAs: 'visualizzazioneApparatiCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('visualizzazioneApparati', visualizzazioneApparatiComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsApprovvigionamento/visualizzazioneApparati/visualizzazioneApparati.cmpt.js
// module id = 17
// module chunks = 0